export function addToWindowDevTools(key: string, value: any) {
  if (!window.traverse) {
    window.traverse = {}
  }

  window.traverse[key] = value
}
